var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.46967 0.96967C1.73594 0.703403 2.1526 0.679197 2.44621 0.897052L2.53033 0.96967L9 7.439L15.4697 0.96967C15.7359 0.703403 16.1526 0.679197 16.4462 0.897052L16.5303 0.96967C16.7966 1.23594 16.8208 1.6526 16.6029 1.94621L16.5303 2.03033L9.53033 9.03033C9.26406 9.2966 8.8474 9.3208 8.55379 9.10295L8.46967 9.03033L1.46967 2.03033C1.17678 1.73744 1.17678 1.26256 1.46967 0.96967Z",
    fill: "#103662",
    stroke: "#103662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.7848fc39ce24ac5b759c22bbba947ee1.svg";
export { ForwardRef as ReactComponent };